import API from '../api';

export const getDeals = (params) => API.get(`/api/v1/trading-history/deals?${params}`)

export const getSymbols = () => API.get('/api/v1/trading-history/values')